import { render } from "./EditStudentList.vue?vue&type=template&id=64482207"
import script from "./EditStudentList.vue?vue&type=script&lang=js"
export * from "./EditStudentList.vue?vue&type=script&lang=js"

import "./EditStudentList.vue?vue&type=style&index=0&id=64482207&lang=css"
script.render = render

export default script